import React, { useCallback, useEffect, useState } from 'react';
import JobBoardPagination from '../../JobBoard/JobBoardPagination';
import AdminRefundsRow from './AdminRefundsRow';
import { getCanceledPayments } from '../../../api/payment/payment.api';
import { useT } from '@repo/common';

const PAGE_SIZE = 12;

const AdminRefundsList = ({ currentFilter = 'ALL' }) => {
  const t = useT();
  const [paymentsList, setPaymentsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // 필터를 바꾸면 1페이지부터
  useEffect(() => {
    setCurrentPage(1);
  }, [currentFilter]);

  const fetchHistory = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await getCanceledPayments(
        currentPage - 1,
        PAGE_SIZE,
        currentFilter,
      );
      setPaymentsList(data.content || []);
      setTotalPages(data.totalPages || 1);
    } catch (error) {
      console.error('환불·취소 내역을 불러오지 못했습니다.', error);
    } finally {
      setIsLoading(false);
    }
  }, [currentPage, currentFilter]);

  useEffect(() => {
    fetchHistory();
  }, [fetchHistory]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0);
  };

  const emptyText =
    currentFilter === 'REQUESTED'
      ? t('No refund requests waiting.', '처리할 환불 요청이 없습니다.')
      : t('Nothing here yet.', '아직 내역이 없습니다.');

  return (
    // 표 머리글이 있는 tabletV 이상에서만 머리글 아래 띠(-mt-5)와 겹친다
    <div className='w-full min-w-0 flex flex-col justify-between rounded-[20px] tabletV:rounded-[30px] overflow-hidden px-2 pt-4 pb-10 bg-grayscale-gray00 gap-10 tabletV:-mt-5 relative z-10 min-h-[400px] tabletV:min-h-[1112px]'>
      <div className='flex flex-col gap-2'>
        {isLoading ? (
          <div className='w-full p-10 flex justify-center text-text-placeholder typo-b14 h-[400px] tabletV:h-[1112px]'>
            {t('Loading...', '불러오는 중...')}
          </div>
        ) : paymentsList.length === 0 ? (
          <div className='w-full p-10 flex items-center justify-center text-text-placeholder typo-b14 h-[400px] tabletV:h-[1112px]'>
            <div className='pb-6'>{emptyText}</div>
          </div>
        ) : (
          paymentsList.map((item, index) => (
            <AdminRefundsRow
              key={item.canceledSerialNumbers ?? item.invoiceNumber ?? index}
              item={item}
              onFetch={fetchHistory}
            />
          ))
        )}
      </div>

      <JobBoardPagination
        isMyPage
        current={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default AdminRefundsList;
